export default {
  title: "Page Not Found",
  description: `The page you are looking for might have been removed, had its
              <br /> name changed, or is temporarily unavailable.`,
};
